import { ControlValueAccessor } from '@angular/forms';

export class FileControlValueAccessor<T> implements ControlValueAccessor {
  protected innerValue: T;
  private onTouch: any;
  private onModelChange: any;
  public disabled: boolean;

  get value(): T {
    return this.innerValue;
  }

  set value(setValue: T) {
    if (this.innerValue !== setValue && !this.disabled) {
      this.innerValue = setValue;
      if (this.onModelChange) {
        this.onModelChange(setValue);
      }
    }
  }

  writeValue(value: T): void {
    if (this.innerValue !== value) {
      this.innerValue = value;
    }
  }

  registerOnChange(changeFunction: (value: any) => void): void {
    this.onModelChange = changeFunction;
  }

  registerOnTouched(touchedFunction: () => void): void {
    this.onTouch = touchedFunction;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
